// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__z7vJH","label":"Radio_label__38cRA","checkMark":"Radio_checkMark__181l_","disabled":"Radio_disabled__2P6Wk"};